import React, { useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import { debouncedApiCall } from '../../../utils/app.utils';
import StateComponents from '../../../components/state-component/StateComponents';
import ContainerButton from '../../../components/button/ContainerButton';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import { useTranslation } from 'react-i18next';
import ManageState from './manageState';
import ModalCustom from '../../../components/modal/ModalCustom';
import { alertActive } from '../../../components/alert/swal';
import { ADMISSION_STATUS, renderStatus } from '../history-online-Admission/enum/admission.enum';

export default function TermPayment() {
    const { t, i18n } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,

        setKeyword,
        degree,
        faculty,
        id_degree,
        set_id_degree,
        id_faculty,
        set_id_faculty,
        handleSubmit,
        setShowModal,
        showModal,
        student_no,
        // url_payment_term,
        set_student_no,
        // set_url_payment_term,
        handleCloseModal,
        handleDownloadFile,
        status,
        set_status
    } = ManageState()

    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("TERM_PAYMENT")}

                content={
                    <div className='w-full'>
                        <ContainerButton
                            justifyContent='flex-end'
                            buttonData={[
                                {
                                    buttonProps: {
                                        onClick: () => {
                                            // setShowModal('ADD')
                                            alertActive(t("TERM_PAYMENT"), t("TERM_PAYMENT_ASK_TERM_PAYMENT"), undefined, undefined, async () => {
                                                handleSubmit()
                                            })
                                        }
                                    },
                                    key: "DOWNLOAD_CSV",
                                    label: t("TERM_PAYMENT"),
                                    seq: 1,
                                    type: "SEND"
                                },
                                {
                                    buttonProps: {
                                        onClick: () => {
                                            // setShowModal('ADD')
                                            handleDownloadFile('excel')
                                        }
                                    },
                                    key: "DOWNLOAD_CSV",
                                    label: t("LIST_APPLICANTS_DOWNLOAD_EXCEL"),
                                    seq: 2,
                                    type: "DOWNLOAD_CSV"
                                },
                                {
                                    buttonProps: {
                                        onClick: () => {
                                            // setShowModal('ADD')
                                            handleDownloadFile('pdf')
                                        }
                                    },
                                    key: "DOWNLOAD_PDF",
                                    label: t("TERM_PAYMENT_DOWNLOAD_PDF"),
                                    seq: 3,
                                    type: 'DOWNLOAD_PDF'
                                },
                            
                            ]}
                        />
                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            sxContainer={{ marginTop: "10px" }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        placeholder: t("TERM_PAYMENT_SEARCH_NAME"),
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_id_degree(e.target.value)
                                        },
                                        options: [{
                                            label: t('TERM_PAYMENT_ALL_LEVELS'),
                                            value: "ALL",
                                        }, ...degree?.map((item: any) => {
                                            return {
                                                label: i18n.language === "en" ? (item?.degree_name_eng || item?.degree_name) : item?.degree_name,
                                                value: item?.id_degree,
                                            }
                                        })],
                                        selectId: "",
                                        value: id_degree || '',
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_id_faculty(e.target.value)
                                        },
                                        options: [{
                                            label: t('TERM_PAYMENT_ALL_COURSES'),
                                            value: "ALL",
                                        }, ...faculty?.map((item: any) => {
                                            return {
                                                label: i18n.language === "en" ? (item?.faculty_name_eng || item?.faculty_name) : item?.faculty_name,
                                                value: item?.id_faculty,
                                            }
                                        })],
                                        selectId: "",
                                        value: id_faculty || '',
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_status(e.target.value)
                                        },
                                        options: [
                                            {
                                                label: t('TERM_PAYMENT_ALL_STATUS'),
                                                value: "ALL",
                                            },
                                            {
                                                label: renderStatus(ADMISSION_STATUS.INTERVIEW_SUCCESS),
                                                value: ADMISSION_STATUS.INTERVIEW_SUCCESS,
                                            },
                                            {
                                                label: renderStatus(ADMISSION_STATUS.WAITING_FOR_TUITION_PAYMENT),
                                                value: ADMISSION_STATUS.WAITING_FOR_TUITION_PAYMENT,
                                            },
                                            {
                                                label: renderStatus(ADMISSION_STATUS.WAITING_FOR_VERIFICATION_TUITION_PAYMENT),
                                                value: ADMISSION_STATUS.WAITING_FOR_VERIFICATION_TUITION_PAYMENT,
                                            },
                                            {
                                                label: renderStatus(ADMISSION_STATUS.TUITION_PAYMENT_REVIEW),
                                                value: ADMISSION_STATUS.TUITION_PAYMENT_REVIEW,
                                            },
                                            {
                                                label: renderStatus(ADMISSION_STATUS.TUITION_PAYMENT_SUCCESS),
                                                value: ADMISSION_STATUS.TUITION_PAYMENT_SUCCESS,
                                            },
                                            ],
                                        selectId: "",
                                        value: status || '',
                                    }
                                },

                            ]}
                        />

                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>
                }
            />
            {/* {showModal && (
                <ModalCustom
                    open
                    title={'แจ้งค่าเทอม'}
                    subTitle={t("กรุณาระบุข้อมูล")}
                    // maxWidth={600}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !student_no || !url_payment_term,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleSubmit() }
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                typeProps={[


                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            // md: 6
                                        },
                                        fieldProps: {
                                            heading: "รหัสนักศึกษา",
                                            onChange: (e) => {
                                                set_student_no(e.target.value)
                                            },
                                            value: student_no || '',
                                        
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            // md: 6
                                        },
                                        fieldProps: {
                                            heading: "ลิงก์ชำระเงิน",
                                            onChange: (e) => {
                                                set_url_payment_term(e.target.value)
                                            },
                                            value: url_payment_term || '',
                                        
                                        }
                                    },
                                ]} />
                        </div>
                    }
                />
            )} */}
        </div>
    )
}
